import { useNavigate } from 'react-router';
import { GridColDef, GridRowParams } from '@mui/x-data-grid';

import {
    DataGrid,
    DataGridCard,
    dataGridNestedObjectValueGetter,
} from '@barboxx/admin-components';
import { PourFormat, ServingContainer } from '@barboxx/models';

const columns: GridColDef<PourFormat>[] = [
    {
        field: 'pourType.name',
        headerName: 'Pour Type',
        width: 170,
        flex: 1,
        valueGetter: dataGridNestedObjectValueGetter,
    },
    {
        field: 'productCategory.name',
        headerName: 'Alcohol Category',
        width: 170,
        valueGetter: dataGridNestedObjectValueGetter,
    },
    {
        field: 'packagingFormat.name',
        headerName: 'Packaging Format',
        width: 170,
        valueGetter: dataGridNestedObjectValueGetter,
    },
    {
        field: 'volumeOz',
        headerName: 'Volume (oz)',
        width: 130,
        maxWidth: 130,
        align: 'right',
        headerAlign: 'right',
    },
    {
        field: 'volumeMl',
        headerName: 'Volume (ml)',
        width: 130,
        maxWidth: 130,
        align: 'right',
        headerAlign: 'right',
    },
    {
        field: 'isDefault',
        headerName: 'Default',
        width: 130,
        align: 'right',
        headerAlign: 'right',
        type: 'boolean',
    },
];

interface Props {
    servingContainer: ServingContainer.DetailsResponse;
}

export const PourFormatsCard = ({ servingContainer }: Props) => {
    const navigate = useNavigate();

    const handleRowClick = (params: GridRowParams) => {
        navigate(`${params.id}`);
    };

    return (
        <DataGridCard title="Pour Formats List">
            <DataGrid
                columns={columns}
                disableColumnMenu
                disableRowSelectionOnClick
                paginationMode="client"
                onRowClick={handleRowClick}
                rows={servingContainer.pourFormats}
            />
        </DataGridCard>
    );
};
